import { memo } from "react";
import "./ChatCampaignWizard.scss";

export interface ChatChoiceOption<TValue> {
  value: TValue;
  label: string;
}

interface ChatChoiceStepProps<TValue> {
  options: ChatChoiceOption<TValue>[];
  onSelect: (_value: TValue) => void;
  question?: string;
  primaryValue?: TValue;
  isAnswered?: boolean;
}

const ChatChoiceStep = <TValue extends string | boolean>({
  options,
  onSelect,
  question,
  primaryValue,
  isAnswered = false,
}: ChatChoiceStepProps<TValue>) => (
  <div className="chat-choice-step">
    {question && <div className="message-bubble bot-bubble chat-choice-step__question">{question}</div>}
    {!isAnswered && (
      <div className="confirm-buttons" role="group" aria-label={question}>
        {options.map(({ value, label }) => (
          <button
            key={String(value)}
            type="button"
            className={`button ${value === primaryValue ? "button--primary" : "button--outline"}`}
            onClick={() => onSelect(value)}
          >
            {label}
          </button>
        ))}
      </div>
    )}
  </div>
);

export default memo(ChatChoiceStep) as typeof ChatChoiceStep;
